/** Relative URL paths for API versioning and Devise/session endpoints (used by urls.js and 401 handling). */

export const api_url = '/api/v1';
export const api_v2_url = '/api/v2';

export const login_url = '/users/sign_in';
export const logout_url = '/users/sign_out';
export const change_password_url = '/users';
export const reset_password_url = '/users/password';
